import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "variant", "responsive", "upgradeSource"],
  _excluded2 = ["children", "variant", "upgradeSource"];
import { Button } from 'breeze-intelligence-kit';
import { UpgradeIcon } from 'foundations-assets';
import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const useOnUpgrade = upgradeSource => {
  const {
    openUpgradeModal: onUpgrade
  } = useUpgradeModal(upgradeSource);
  return {
    onUpgrade
  };
};
export const UpgradeLink = _ref => {
  let {
      children,
      variant = 'link-on-dark',
      responsive = true,
      upgradeSource
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    onUpgrade
  } = useOnUpgrade(upgradeSource);
  return /*#__PURE__*/_jsx(Button, Object.assign({}, rest, {
    onClick: onUpgrade,
    responsive: responsive,
    variant: variant,
    children: children
  }));
};
export const UpgradeLinkIcon = _ref2 => {
  let {
      children,
      variant = 'link',
      upgradeSource
    } = _ref2,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  const {
    onUpgrade
  } = useOnUpgrade(upgradeSource);
  return /*#__PURE__*/_jsxs(Button, Object.assign({}, rest, {
    onClick: onUpgrade,
    variant: variant,
    children: [/*#__PURE__*/_jsx(Button.Icon, {
      children: /*#__PURE__*/_jsx(UpgradeIcon, {})
    }), children]
  }));
};